import React from 'react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { TrashIcon, ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';

const CompetitorListNew = ({ competitors, removeCompetitor, formatPrice }) => {
  if (!competitors || competitors.length === 0) {
    return (
      <Card className="p-12 text-center">
        <div className="flex flex-col items-center gap-4">
          <div className="text-6xl">👥</div>
          <div>
            <h3 className="text-lg font-semibold">هنوز هیچ رقیبی تعریف نشده</h3>
            <p className="text-muted-foreground mt-2">
              از بخش پیشنهادات بالا رقبا را اضافه کنید
            </p>
          </div>
        </div>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold">لیست رقبا</h2>
        <Badge variant="outline" className="text-sm">
          {competitors.length} مورد
        </Badge>
      </div>

      <div className="grid gap-3">
        {competitors.map(competitor => (
          <Card
            key={competitor.id}
            className="p-4 hover:shadow-lg transition-all duration-200 cursor-pointer group"
            onClick={() => window.open(`https://basalam.com/p/${competitor.competitor_product_id}`, '_blank')}
          >
            <div className="flex items-start gap-4">
              {/* عکس */}
              <img
                src={competitor.photo_url || '/placeholder.png'}
                alt={competitor.name}
                className="w-20 h-20 rounded-lg object-cover shadow-sm group-hover:shadow-md transition-shadow"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = '/placeholder.png';
                }}
              />

              {/* اطلاعات */}
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2 mb-2">
                  <h3 className="font-semibold text-base line-clamp-2 group-hover:text-primary transition-colors">
                    {competitor.name}
                  </h3>
                  <ArrowTopRightOnSquareIcon className="h-4 w-4 text-muted-foreground flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>

                <div className="space-y-2">
                  <p className="text-lg font-bold text-primary">
                    {formatPrice(competitor.current_price)}
                  </p>

                  <div className="flex flex-wrap gap-2">
                    {competitor.vendor_name && (
                      <Badge variant="outline" className="text-xs">
                        🏪 {competitor.vendor_name}
                      </Badge>
                    )}
                    {competitor.vendor_city && (
                      <Badge variant="secondary" className="text-xs">
                        📍 {competitor.vendor_city}
                      </Badge>
                    )}
                  </div>
                </div>
              </div>

              {/* دکمه حذف */}
              <Button
                variant="destructive"
                size="icon"
                onClick={(e) => {
                  e.stopPropagation();
                  if (window.confirm('آیا از حذف این رقیب مطمئن هستید؟')) {
                    removeCompetitor(competitor.id);
                  }
                }}
                className="flex-shrink-0"
                title="حذف رقیب"
              >
                <TrashIcon className="h-4 w-4" />
              </Button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default CompetitorListNew;
